import { render, staticRenderFns } from "./FreelancersDeleteModal.vue?vue&type=template&id=7fd5294b&scoped=true"
import script from "./FreelancersDeleteModal.vue?vue&type=script&lang=js"
export * from "./FreelancersDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd5294b",
  null
  
)

export default component.exports